import React from 'react';
import { useParams } from 'react-router-dom';
import CoWorkingNewsDetail from '../components/CoWorkingNewsDetail';

const NewsDetails: React.FC = () => {
    const { newsId } = useParams<{ newsId: string }>();

    if (!newsId) {
        return <div>Error: No news ID found in the URL.</div>;
    }

    return (
        <CoWorkingNewsDetail newsId={newsId} />
    );
};

export default NewsDetails;
